"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchiveExpansionError = exports.ArchiveExpansionFailure = exports.ArchiveEntryRejection = void 0;
exports.expandProjectArchive = expandProjectArchive;
exports.firstExceededBound = firstExceededBound;
const fflate_1 = require("fflate");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
var ArchiveEntryRejection;
(function (ArchiveEntryRejection) {
    ArchiveEntryRejection["UnsafePath"] = "unsafe_path";
    ArchiveEntryRejection["TooLarge"] = "too_large";
})(ArchiveEntryRejection || (exports.ArchiveEntryRejection = ArchiveEntryRejection = {}));
var ArchiveExpansionFailure;
(function (ArchiveExpansionFailure) {
    ArchiveExpansionFailure["Unreadable"] = "unreadable";
    ArchiveExpansionFailure["TooManyEntries"] = "too_many_entries";
    ArchiveExpansionFailure["ExpansionTooLarge"] = "expansion_too_large";
    ArchiveExpansionFailure["CompressionRatioTooHigh"] = "compression_ratio_too_high";
})(ArchiveExpansionFailure || (exports.ArchiveExpansionFailure = ArchiveExpansionFailure = {}));
class ArchiveExpansionError extends Error {
    constructor(failure, message) {
        super(message);
        this.name = 'ArchiveExpansionError';
        this.failure = failure;
    }
}
exports.ArchiveExpansionError = ArchiveExpansionError;
async function expandProjectArchive(data, tool) {
    const rejected = [];
    const failures = [];
    let acceptedCount = 0;
    let expandedBytes = 0;
    const acceptEntry = (info) => {
        const path = normalizeEntryPath(info.name);
        if (path === '' || path.endsWith('/')) {
            return false;
        }
        if (isUnsafeEntryPath(path)) {
            rejected.push({ path: info.name, reason: ArchiveEntryRejection.UnsafePath });
            return false;
        }
        if (hasBlockedSegment(path) || sigma_engine_shared_1.Files.isToolGeneratedArtifact(path, tool)) {
            return false;
        }
        if (info.originalSize > sigma_engine_shared_1.Files.UPLOAD_LIMITS.MAX_FILE_SIZE_BYTES) {
            rejected.push({ path, reason: ArchiveEntryRejection.TooLarge });
            return false;
        }
        acceptedCount += 1;
        expandedBytes += info.originalSize;
        const breach = firstExceededBound({
            entryCount: acceptedCount,
            expandedBytes,
            storedBytes: data.length,
        });
        if (breach !== null) {
            failures.push(breach);
            return false;
        }
        return true;
    };
    const unzipped = await new Promise((resolve, reject) => {
        (0, fflate_1.unzip)(data, { filter: acceptEntry }, (error, result) => {
            if (error) {
                reject(new ArchiveExpansionError(ArchiveExpansionFailure.Unreadable, error.message));
                return;
            }
            resolve(result);
        });
    });
    const failure = failures[0];
    if (failure !== undefined) {
        throw new ArchiveExpansionError(failure, `Archive expansion exceeded its limits (${failure})`);
    }
    const names = Object.keys(unzipped);
    const wrapper = findWrapperDirectory(names.map(normalizeEntryPath));
    const members = [];
    for (const name of names) {
        const contents = unzipped[name];
        if (contents === undefined) {
            continue;
        }
        const path = normalizeEntryPath(name);
        members.push({ path: wrapper === null ? path : path.slice(wrapper.length), contents });
    }
    return { members, rejected };
}
function firstExceededBound(declared) {
    if (declared.entryCount > sigma_engine_shared_1.Files.UPLOAD_LIMITS.MAX_FILES) {
        return ArchiveExpansionFailure.TooManyEntries;
    }
    if (declared.expandedBytes > sigma_engine_shared_1.Files.ARCHIVE_LIMITS.MAX_EXPANDED_BYTES) {
        return ArchiveExpansionFailure.ExpansionTooLarge;
    }
    if (declared.expandedBytes > declared.storedBytes * sigma_engine_shared_1.Files.ARCHIVE_LIMITS.MAX_COMPRESSION_RATIO) {
        return ArchiveExpansionFailure.CompressionRatioTooHigh;
    }
    return null;
}
function normalizeEntryPath(name) {
    return name.replace(/\\/g, '/').replace(/^\.\//, '');
}
function isUnsafeEntryPath(path) {
    return path.startsWith('/') || /^[a-z]:/i.test(path) || path.split('/').includes('..');
}
function hasBlockedSegment(path) {
    const blocked = sigma_engine_shared_1.Files.BLOCKED_DIRECTORIES;
    return path.split('/').some((segment) => blocked.includes(segment));
}
function findWrapperDirectory(paths) {
    const first = paths[0];
    if (first === undefined) {
        return null;
    }
    const slash = first.indexOf('/');
    if (slash < 0) {
        return null;
    }
    const prefix = first.slice(0, slash + 1);
    return paths.every((path) => path.startsWith(prefix)) ? prefix : null;
}
//# sourceMappingURL=project-archive.js.map